import { Collapse, Form, Select, Typography } from "antd";
import { useTranslation } from "react-i18next";

import FilterPanel from "@/warRoom/components/FilterPanel";
import { datasetByKey } from "@/warRoom/datasets/registry";
import { formsForDataset } from "@/warRoom/graph/chartForms";
import type { ChartType } from "@/warRoom/graph/spec";
import {
  useGraphStore,
  useSelectedWidget,
  useVisibleDatasets,
} from "@/warRoom/store/useGraphStore";

import AxisPanel from "./AxisPanel";

const { Text } = Typography;

/**
 * 第 ③ 步：編輯「選中的那張圖」。
 * 畫布上點哪一張，這裡就是那一張的資料、圖型、X / Y 軸與篩選 ——
 * 每張圖各自成立，所以篩選也在這裡，不在畫布上方。
 */
export default function InspectorPanel() {
  const { t } = useTranslation();
  const widget = useSelectedWidget();
  const setWidgetDataset = useGraphStore((s) => s.setWidgetDataset);
  const setWidgetChartType = useGraphStore((s) => s.setWidgetChartType);
  const datasets = useVisibleDatasets();

  if (!widget) {
    return (
      <Text type="secondary" style={{ fontSize: 12 }}>
        {t("warRoom.inspector.empty")}
      </Text>
    );
  }

  const { spec } = widget;
  const dataset = spec.datasetKey ? datasetByKey(spec.datasetKey) : undefined;
  const forms = dataset ? formsForDataset(dataset) : [];

  return (
    <div>
      <Form layout="vertical" size="small" style={{ marginBottom: 0 }}>
        <Form.Item
          label={t("warRoom.inspector.dataset")}
          style={{ marginBottom: 10 }}
        >
          <Select
            value={spec.datasetKey ?? undefined}
            onChange={(v) => setWidgetDataset(widget.id, v)}
            options={datasets.map((d) => ({ value: d.key, label: d.label }))}
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item
          label={t("warRoom.inspector.chartType")}
          style={{ marginBottom: 10 }}
        >
          <Select
            value={spec.chartType ?? undefined}
            onChange={(v) => setWidgetChartType(widget.id, v as ChartType)}
            options={forms.map((f) => ({ value: f.type, label: f.label }))}
          />
        </Form.Item>
      </Form>

      <AxisPanel />

      <Collapse
        ghost
        size="small"
        className="more-settings"
        items={[
          {
            key: "filter",
            label: (
              <span style={{ fontSize: 12 }}>
                {t("warRoom.inspector.filter")}
              </span>
            ),
            children: <FilterPanel />,
          },
        ]}
      />
    </div>
  );
}
